import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import { convertToStandard } from 'appSrc/utils/list-article';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import { UserAvatar } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';


class ContentFocusedLAStackCard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( item ) => {
        const youtubeImg = item.video_id && convertYouTubeIdToImg( item.video_id );
        const coverImage = item.cover_image || youtubeImg || defaultListCoverImage;

        return (
            <div className={ style.imageWrapper }>
                <img src={ coverImage } />
            </div>
        );
    }
    convertHTMLString = ( input ) => {
        var output = input.replace( /<[^>]*>/gm, '' );
        return output;
    }



    render() {
        const item = convertToStandard( this.props.item );
        const author = item.author || {};
        const profession = ( author.profession || {} ).title;

        var description = this.convertHTMLString( item.text || '' );

        const movieMetaData = {
            attached_to: `${ item.type }_cover_video`,
            attached_id: item.id,
            video_author_id: item.userid,
        };

        const topCategory = item.categories.find( ( cat ) => ( cat.parent_id == null ) );

        return (
            <div className={ `${ style.contentFocusedStackCard } ${ this.props.className }`.trim() }>
                <Link to={ item.internal_link }>
                    <AspectRatio ratio='16/9' className={ style.coverWrapper }>
                        { this.renderCoverImage( item ) }
                        <div className={ style.overlayInfo }>
                            { item.video_id &&
                                <TheaterPlayIcon className={ style.playButton } youtubeId={ item.video_id }
                                metaData={ movieMetaData } />
                            }
                        </div>
                    </AspectRatio>
                </Link>
                <div className={ style.info }>
                    <div className={ style.infoContainer }>
                        <Link to={ item.internal_link } className={ style.listLink }>
                            { topCategory &&
                                <p className={ style.category }>{ topCategory.name }</p>
                            }
                            <p className={ style.name }>{ item.title }</p>
                            { profession &&
                                <p className={ style.profession }>{ profession }</p>
                            }
                            { description &&
                                <TextTruncate
                                text={ description }
                                title={ description } line={ 2 }
                                containerClassName={ style.description } />
                            }
                        </Link>
                        <Link to={ `/${ author.slug }` } className={ style.authorLink }>
                            <UserAvatar src={ author.avatar } className={ style.avatar } size={ 40 } />
                            <span className={ style.displayName }>{ author.displayName }</span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
ContentFocusedLAStackCard.propTypes = {
    item: PropTypes.object.isRequired,
};
ContentFocusedLAStackCard.defaultProps = {
    className: '',
};

export default connect()( ContentFocusedLAStackCard );
